import { styled, utils } from 'ui/theme';

export const Image = {
  Component: styled('img')`
    border-style: none;

    // Opacity
    &[data-opacity='0'] {
      opacity: 0;
    }

    &[data-opacity='25'] {
      opacity: 25%;
    }

    &[data-opacity='50'] {
      opacity: 50%;
    }

    &[data-opacity='75'] {
      opacity: 75%;
    }

    // Ratio
    &[data-ratio='1x1'] {
      ${utils.ratio('1x1')}
    }

    &[data-ratio='4x3'] {
      ${utils.ratio('4x3')}
    }

    &[data-ratio='16x9'] {
      ${utils.ratio('16x9')}
    }

    &[data-ratio='21x9'] {
      ${utils.ratio('21x9')}
    }
  `,
};
